/** Routes that people outside the company can open without a WebApps login. */
export function isPublicAnonymousPath(path = window.location.pathname): boolean {
    const value = path.toLowerCase()
    return (
        value.includes('/site-visitor') ||
        value.includes('/punch-list-complete') ||
        value.includes('/tire-dispatch') ||
        value.includes('/subcontractor-training') ||
        value.includes('/signin') ||
        value.includes('/signup') ||
        value.includes('/mfa-setup') ||
        value.includes('/mfa-verify') ||
        isPublicSwpppPath(value)
    )
}

/** QR site card, emailed inspection report, and operator action sign-off. */
export function isPublicSwpppPath(path = window.location.pathname): boolean {
    const value = path.toLowerCase().split('?')[0]
    return value.startsWith('/swppp/site/') || value.startsWith('/swppp/report/') || value.startsWith('/swppp/action/')
}
